export const FeaturesSubMenuItems = [
    {
        id: 'EzSubMenu_TimeSheets',
        EzMarketingPageAssetId: 'TIMESHEET_APP',
        title: 'Timesheets',
        link: '/time-tracking/time-sheet.html',
        altLink: '/marketing/time-sheet.html'
    },
    {
        id: 'EzSubMenu_MobileApps',
        EzMarketingPageAssetId: 'MOBILE_TIME_CLOCK_APPS',
        title: 'Mobile Apps',
        link: '/time-tracking/mobile-time-clock-apps.html',
        altLink: '/marketing/mobile-time-clock-apps.html'
    },
    {
        id: 'EzSubMenu_KioskApps',
        EzMarketingPageAssetId: 'PORTABLE_TIME_CLOCK_KIOSK',
        title: 'Kiosk App',
        // TODO: Uncomment the link below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // link: '/time-tracking/portable-time-clock-kiosk-app.html',
        link: '/time-tracking/portable-time-clock-kiosk-app/index.html',
        // TODO: Uncomment the altLink below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        //altLink: '/marketing/portable-time-clock-kiosk-app.html'
        altLink: '/time-tracking/portable-time-clock-kiosk-app/index.html'
    },
    {
        id: 'EzSubMenu_GPSVerification',
        EzMarketingPageAssetId: 'GPS_MOBILE',
        title: 'GPS Verification',
        link: '/time-tracking/gps-time-clock.html',
        altLink: '/marketing/gps-time-clock.html'
    },
    {
        id: 'EzSubMenu_JobTracking',
        EzMarketingPageAssetId: 'JOB_TRACKING_SOFTWARE',
        title: 'Job Tracking',
        link: '/time-tracking/job-tracking-software.html',
        altLink: '/marketing/job-tracking-software.html'
    },
    {
        id: 'EzSubMenu_EmployeeScheduling',
        EzMarketingPageAssetId: 'EMPLOYEE_SCHEDULING_SOFTWARE',
        title: 'Employee Scheduling',
        link: '/time-tracking/schedule.html',
        altLink: '/marketing/schedule.html'
    },
    {
        id: 'EzSubMenu_PayrollIntegration',
        EzMarketingPageAssetId: 'INTEGRATIONS',
        title: 'Payroll Integration',
        // TODO: Uncomment the link below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // TODO: Enable marketing link once page is moved to ezclocker-marketing-pages
        // link: '/time-tracking/integrations.html',
        link: '/time-tracking/integrations/index.html',
        // TODO: Uncomment the altLink below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // altLink: '/marketing/integrations.html'
        altLink: '/time-tracking/integrations/index.html'
    },
];
